import { useState, useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";

export const useAuthentication = () => {
  const { authState, oktaAuth } = useOktaAuth();

  const logout = () => {
    oktaAuth.signOut();
    localStorage.clear();
    sessionStorage.clear();
  };
  const authenticated = authState && authState.isAuthenticated;
  const renewToken = async () => {
    const newToken = await oktaAuth.token.renewTokens();
  };

  return { authenticated, logout, renewToken };
};

export const useUser = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (authState && authState.isAuthenticated && oktaAuth && oktaAuth.token) {
      oktaAuth.token.getUserInfo().then((info) => setUser(info));
    }
  }, [authState, oktaAuth]);

  return [user];
};
